import { cardBase, cardShadow, homeColors, linkButtonReset } from '../../tokens'

const styles = () => ({
  root: {
    ...cardBase,
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    minHeight: 176,
    padding: '20px 20px 22px',
    boxShadow: cardShadow,
  },
  rootDone: {
    opacity: 0.6,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
  },
  number: {
    width: 24,
    height: 24,
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    fontWeight: 700,
    background: homeColors.badgeSurface,
    color: homeColors.badgeText,
  },
  numberCurrent: {
    background: homeColors.ink,
    color: '#FFFFFF',
  },
  numberDone: {
    background: homeColors.success,
    color: '#FFFFFF',
  },
  checkIcon: {
    width: 14,
    height: 14,
  },
  duration: {
    fontSize: '13px',
    color: homeColors.subtle,
  },
  title: {
    fontSize: '17px',
    fontWeight: 700,
    letterSpacing: '-0.015em',
    color: homeColors.ink,
  },
  titleDone: {
    textDecoration: 'line-through',
  },
  description: {
    fontSize: '14px',
    lineHeight: 1.5,
    color: homeColors.muted,
  },
  button: {
    marginTop: 'auto',
    alignSelf: 'flex-start',
    padding: '10px 16px',
    border: 0,
    borderRadius: '8px',
    background: homeColors.primary,
    color: '#FFFFFF',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '14px',
    fontWeight: 600,
    boxShadow: '0 2px 4px rgba(145,158,171,.32)',
    '&:hover': {
      background: homeColors.primaryDark,
    },
  },
  link: {
    ...linkButtonReset,
    marginTop: 'auto',
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '14px',
    fontWeight: 600,
    color: homeColors.primary,
  },
  linkIcon: {
    width: 14,
    height: 14,
    flex: 'none',
  },
})

export default styles
